<template>
  <section class="leaderboard">
    <div class="_bg-light">
      <div class="container _py-16 _py-md-12 _px-md-4 _py-sm-8">
        <h1 class="_tc-dark _fs-48 _fs-sm-32 _lh-38 _lh-64 _fw-700 _mb-6">
          Лидерборд
        </h1>
        <div class="_tc-dark-grey _fs-16 _lh-24">
          Лидерборд отображает рейтинг пользователей. Призовые места в рейтинге
          занимают пользователи, накопившие больше всех коинов на балансе
          Личного Кабинета. 1 раз в 10 минут счетчик на лидерборде обновляется
          для всех пользователей. Каждый вторник пользователи, занявшие три
          призовых места, попадают в Топ и в качестве награды получают
          Достижение и бонусные коины.
        </div>
      </div>
    </div>
    <div class="container _px-md-4 _py-16 _py-sm-12">
      <div class="leaderboard__table">
        <div
          class="leaderboard__table-item"
          :class="{
            'leaderboard__table-item_isChampion': item.place_number < 4,
            'leaderboard__table-item_isUser': item.current_user,
          }"
          v-for="(item, i) in getLeaderboard"
          :key="i"
        >
          <div class="leaderboard__table-item-number _mr-12" :data-head="'№'">
            <svg
              v-if="item.place_number < 4"
              width="57"
              height="55"
              viewBox="0 0 57 55"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22.5598 2.30384C25.9416 -0.715645 31.0584 -0.715645 34.4402 2.30384C36.1576 3.83733 38.4044 4.64665 40.7052 4.559L40.8799 4.55235C45.3467 4.38219 49.2169 7.62996 49.8318 12.0575C50.1468 14.325 51.3601 16.3905 53.1801 17.7791C56.7446 20.4985 57.6608 25.5228 55.2431 29.2986C54.01 31.2244 53.5935 33.5625 54.0848 35.7958C55.0441 40.1561 52.517 44.5299 48.2595 45.8738L48.1126 45.9202C45.9236 46.6111 44.0902 48.1337 43.0068 50.1573C40.8842 54.1221 36.0417 55.8314 31.8689 54.1541C29.7282 53.2937 27.2718 53.2937 25.1311 54.1541C20.9583 55.8314 16.1158 54.1221 13.9932 50.1573C12.9098 48.1337 11.0764 46.6111 8.88743 45.9202L8.74051 45.8738C4.48299 44.5299 1.95588 40.1561 2.91517 35.7958C3.40652 33.5625 2.98996 31.2244 1.75687 29.2986C-0.660753 25.5228 0.255352 20.4985 3.81989 17.7791C5.63994 16.3905 6.85324 14.325 7.16817 12.0575C7.78311 7.62997 11.6533 4.38219 16.1201 4.55235L16.2948 4.559C18.5956 4.64665 20.8424 3.83733 22.5598 2.30384Z"
                fill="#C6579A"
              />
            </svg>
            <span
              class="_fs-20 _lh-24"
              :class="{
                '_tc-white': item.place_number < 4,
                '_tc-green-second': item.place_number > 3,
              }"
              >{{ item.place_number }}</span
            >
          </div>
          <div class="leaderboard__table-item-container">
            <div
              class="leaderboard__table-item-username"
              :data-head="'Имя пользователя'"
            >
              <div class="leaderboard__table-item-avatar">
                <svg
                  v-if="!item.user_photo"
                  width="52"
                  height="52"
                  viewBox="0 0 52 52"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M43.3337 45.5V41.1667C43.3337 38.8681 42.4206 36.6637 40.7953 35.0384C39.1699 33.4131 36.9655 32.5 34.667 32.5H17.3337C15.0351 32.5 12.8307 33.4131 11.2054 35.0384C9.58008 36.6637 8.66699 38.8681 8.66699 41.1667V45.5"
                    stroke="#B2B4B2"
                    stroke-width="4.33333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M25.9997 23.8333C30.7861 23.8333 34.6663 19.9531 34.6663 15.1667C34.6663 10.3802 30.7861 6.5 25.9997 6.5C21.2132 6.5 17.333 10.3802 17.333 15.1667C17.333 19.9531 21.2132 23.8333 25.9997 23.8333Z"
                    stroke="#B2B4B2"
                    stroke-width="4.33333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <img v-else :src="item.user_photo" />
              </div>
              <span class="d-none d-md-block"
                >{{ item.first_name }} {{ item.last_name }}</span
              >
            </div>
            <div>
              <div class="leaderboard__table-item-username d-md-none">
                {{ item.user }}
              </div>
              <div class="leaderboard__table-item-cups-container">
                <div
                  class="leaderboard__table-item-cups"
                  :data-head="'Достижения'"
                >
                  <img :src="require('@/assets/img/leaderboard/cup.png')" />
                  <div class="leaderboard__table-item-cups-count">
                    {{ item.achievements_count }}
                  </div>
                </div>

                <div class="leaderboard__table-item-coins" :data-head="'Коины'">
                  <img :src="require('@/assets/img/leaderboard/coins.png')" />
                  <div class="leaderboard__table-item-coins-count">
                    {{ item.coins }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  metaInfo() {
    return { title: "Лидерборд" };
  },
  name: "Leaderboard",
  computed: {
    ...mapGetters(["getLeaderboard"]),
  },
  methods: {
    ...mapActions(["fetchLeaderboard"]),
  },
  async mounted() {
    await this.fetchLeaderboard();
  },
};
</script>

<style lang="scss" scoped>
.leaderboard {
  &__table {
    &-item {
      padding: 15px 30px;
      background: #ffffff;
      border: 1px solid #d6dbe0;
      border-radius: 16px;
      display: grid;
      grid-template-columns: 63px 1fr;
      justify-content: flex-start;
      align-items: center;
      min-height: 87px;
      margin-bottom: 8px;

      @media screen and (max-width: 767px) {
        padding: 16px;
      }

      &_isUser {
        background: #ffffff;
        border: 2px solid #77bb2f;
        border-radius: 16px;
        &.leaderboard__table-item_isChampion {
          background: #ccedb4;
          border: 2px solid #629727;
          border-radius: 16px;
        }
      }

      &_isChampion {
        background: #ebf6e3;
        border: 2px solid #77bb2f;
      }

      &-number {
        position: relative;
        width: 63px;
        display: flex;
        justify-content: center;
        align-items: center;

        @media screen and (max-width: 767px) {
          width: 45px;
        }

        & span {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }

        &::before {
          left: 50% !important;
          transform: translateX(-50%) !important;
        }
      }

      &-username {
        position: relative;
        margin-left: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-family: "Noto-Sans", sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        color: #54585a;

        @media screen and (max-width: 767px) {
          margin-left: 0;
        }
      }

      &-avatar {
        margin-right: 16px;
        width: 50px;
        height: 50px;
        background: #d1d2cd;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;

        @media screen and (max-width: 743px) {
          width: 60px;
          height: 60px;
          margin-right: 16px;
        }

        & img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
          border-radius: 50%;
        }

        & svg {
          width: 80%;
          height: 100%;
          object-fit: cover;
          object-position: bottom;
          border-radius: 50%;
        }
      }

      &-container {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr;
        justify-content: flex-start;
        align-items: center;
      }

      &-cups {
        position: relative;
        margin: 0 auto;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        @media screen and (max-width: 767px) {
          margin: 0;
        }
        & img {
          width: 45px;
          margin-right: 8px;
          @media screen and (max-width: 767px) {
            width: 20px;
          }
        }
        &-count {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 28px;
          height: 28px;
          background: #ffffff;
          padding: 8px;
          border-radius: 50%;
          border: 1px solid #c7c9c7;
          font-family: "Noto-Sans", sans-serif;
          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          line-height: 24px;
          text-align: center;
          color: #25282a;
          @media screen and (max-width: 767px) {
            margin-right: 8px;
            padding: 0;
            border-radius: 0;
            background: transparent;
            border: 0;
            width: auto;
            height: auto;
            font-size: 12px;
            line-height: 12px;

            text-align: left;

            color: #629727;
          }
        }

        &-container {
          display: grid;
          grid-template-columns: 1fr 1fr;
          justify-content: flex-start;
          align-items: center;
        }
      }

      &-coins {
        position: relative;
        margin-left: auto;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        & img {
          width: 45px;
          margin-right: 8px;
          @media screen and (max-width: 767px) {
            width: 26px;
          }
        }
        &-count {
          font-family: "Noto-Sans", sans-serif;
          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          line-height: 24px;
          color: #54585a;
          min-width: 70px;
          @media screen and (max-width: 767px) {
            margin-right: 8px;
            padding: 0;
            border-radius: 0;
            background: transparent;
            border: 0;
            width: auto;
            height: auto;
            font-size: 12px;
            line-height: 12px;

            text-align: left;

            color: #629727;
          }
        }
      }

      &:first-child {
        & *[data-head] {
          &::before {
            position: absolute;
            top: -60px;
            left: 0;
            display: block;
            font-family: "Noto-Sans", sans-serif;
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
            color: #b2b4b2;
            content: attr(data-head) "";

            @media screen and (max-width: 767px) {
              display: none;
            }
          }
        }
      }
    }
  }
}
</style>
